import React from 'react';

export default function Bootstrap() {
    return (
        <div id="bootstrap-page" style={{ background: `url('${process.env.REACT_APP_LOGIN_BG_IMG_FILE}') no-repeat center center fixed` }}>
          <img alt={process.env.REACT_APP_LOGO_LOGIN_ALT} className='logo' src={process.env.REACT_APP_LOGO_LOGIN} />
        </div>
    )
}
